import { OktaAuth } from '@okta/okta-auth-js';

import { DEFAULT_SCOPES, TOKEN_RENEW_WINDOW_SECONDS } from './authConstants';
import type { AuthConfig } from './types/authTypes';

export const buildScopes = (config: AuthConfig) => {
  const configuredScopes = config.scopes && config.scopes.length > 0 ? [...new Set(config.scopes)] : DEFAULT_SCOPES;
  return configuredScopes;
};

export const createOktaClient = (config: AuthConfig, scopes: string[]) => {
  return new OktaAuth({
    issuer: config.issuer,
    clientId: config.clientId,
    redirectUri: config.redirectUri,
    scopes,
    pkce: true,
    decodeAccessTokens: true,
    tokenManager: {
      storage: 'cookie',
      autoRenew: true,
      autoRemove: true,
      expireEarlySeconds: TOKEN_RENEW_WINDOW_SECONDS,
    },
    cookies: {
      secure: true,
      sameSite: 'strict',
      path: '/',
    },
    services: {
      autoRenew: true,
      autoRemove: true,
      renewOnTabActivation: true,
    },
  });
};
